module.exports = __webpack_public_path__ + "img/social-icon-facebook.48268f72.svg";